import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { CHECKSHEETSETTINGDIALOG, DpadZoneType, TV } from '@core/constants';
import { CheckSheetDisplayOrder, SortType } from '@core/models/enums';
import { SessionStorageService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';

@Component({
  selector: 'caremoni-us-menu-right-cs-tsusho',
  templateUrl: './us-menu-right-cs-tsusho.component.html',
  styleUrl: './us-menu-right-cs-tsusho.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class UsMenuRightCsTsuShoComponent {
    @Input() hiddenOverTime: boolean = false;
    @Input() hiddenLeaveUser: boolean = false;
    @Input() midMenuId: number = 0;
    @Input() displayUnits: any[] = [];
    @Input() unitSelected: string[] = [];
    @Input() displayGroups: any[] = [];
    @Input() groupSelected: string[] = [];
    @Input() isShortTimeSettingMenu: boolean = false;
    @Input() displayOrderSelected: CheckSheetDisplayOrder = CheckSheetDisplayOrder.StartTime;
    @Output() onChangeUnitHandle = new EventEmitter();
    @Output() onChangeGroupHandle = new EventEmitter();
    @Output() onCheckboxClickHandle = new EventEmitter();
    @Output() onDisplayOrderClickHandle = new EventEmitter<CheckSheetDisplayOrder>();

    DpadZoneType = DpadZoneType;
    SortType = SortType;
    CheckSheetDisplayOrder = CheckSheetDisplayOrder;
    TV = TV;
    CHECKSHEETSETTINGDIALOG = CHECKSHEETSETTINGDIALOG;

    constructor(
        private dpadControlService: DpadControlService,
        private sessionStorageService: SessionStorageService,
    ) { }

    async ngOnInit(): Promise<void>{
    }

    onCheckboxClick(event: any){
        this.onCheckboxClickHandle.emit(event);
    }

    onDisplayOrderClick(order: CheckSheetDisplayOrder): void {
        this.onDisplayOrderClickHandle.emit(order);
    }

    isDisplayOrderSelected(order: CheckSheetDisplayOrder): boolean {
        return (this.displayOrderSelected ?? CheckSheetDisplayOrder.StartTime) === order;
    }

    onChangeGroup(event: any){
        this.onChangeGroupHandle.emit(event);
    }
    
    onChangeUnit(event: any){
        this.onChangeUnitHandle.emit(event);
    }

}
